import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['checkbox', 'toggleAll']

  connect () {
    this.updateToggleAll()
  }

  toggleAll () {
    const isChecked = this.toggleAllTarget.checked

    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked
    })

    this.toggleAllTarget.indeterminate = false
  }

  checkboxChanged () {
    this.updateToggleAll()
  }

  updateToggleAll () {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter(cb => cb.checked).length

    if (checked === total) {
      this.toggleAllTarget.checked = true
      this.toggleAllTarget.indeterminate = false
      this.toggleAllTarget.classList.remove('text-sorbet')
    } else if (checked === 0) {
      this.toggleAllTarget.checked = false
      this.toggleAllTarget.indeterminate = false
      this.toggleAllTarget.classList.remove('text-sorbet')
    } else {
      this.toggleAllTarget.checked = false
      this.toggleAllTarget.indeterminate = true
      this.toggleAllTarget.classList.add('text-sorbet')
    }
  }

  clearAll () {
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    this.updateToggleAll()
  }
}
